import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			borderProduct: {
				borderRadius: 6,
				display: "flex",
				zIndex: 2
			},
			accordionDetails: {
				padding: 0
			},
			img: {
				display: "flex",
				alignItems: "center",
				background: theme.palette.common.white,
				padding: "10px 5px 10px 10px",
				zIndex: 2,
				borderRadius: 6,
				"& > img": {
					objectFit: "contain"
				}
			},
			body: {
				width: "100%",
				padding: "10px 10px 10px 0px"
			},
			nameProduct: {
				fontSize: 14,
				color: theme.palette.primary.contrastText
			},
			btnDelete: {
				cursor: "pointer",
				"&:hover": {
					opacity: 0.7
				}
			},
			bodyInfoProduct: {
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center"
			},
			mt10: {
				marginTop: 10
			},
			cartType: {
				width: 45,
				fontSize: 14,
				color: theme.palette.info.light
			},
			priceCart: {
				fontWeight: 500,
				color: theme.palette.primary.contrastText,
				fontSize: 14
			},
			customInput: {
				width: 64,
				height: 26,
				border: `1px solid ${theme.palette.grey[800]}`,
				boxSizing: "border-box",
				borderRadius: 2,
				textAlign: "end",
				"& > .MuiInput-underline:before": {
					borderBottom: `1px solid ${theme.palette.grey["A100"]}`,
					content: "none"
				},
				"& > .MuiInput-underline:after": {
					content: "none",
					borderBottom: `1px solid ${theme.palette.grey["A100"]}`
				},
				"& > div > input": {
					fontSize: 14,
					padding: 4,
					textAlign: "end",
					color: theme.palette.primary.contrastText
				}
			}
		}),
	{
		name: "ProductCartItem",
		index: 1
	}
);

export default useStyles;
